<div class="pt-8 pb-16 px-2 md:py-[30px] md:px-[20px] md:px-[50px]">
  @switch (step) {
    @case (1) {
      <div>
        <img class="w-[53px] h-[53px]" src="/assets/v4/icon-expedia-color-bg.svg" alt="" />
        <img class="mx-2" src="/assets/v4/icon-link-arrow.svg" alt="" />
        <img class="w-[53px] h-[53px]" src="/assets/v4/icon-hostex-color.svg" alt="" />
      </div>

      <div class="text-l font-bold text-left mt-[30px]">
        {{ "channel-connect_expedia_html_标题" | translate }}
        <!-- Connect with Booking.com -->
      </div>

      <div class="text-m mt-[30px]">
        {{ "channel-connect_expedia_html_描述" | translate }}
        <!-- Hostex is an official Booking.com connectivity partner, so we can connect with your account reliably and securely. -->
      </div>

      <div class="text-m mt-[30px]">
        <div>
          {{ "channel-connect_expedia_html_注意事项" | translate }}
          <!-- Before you start connecting, you need to know the following things. -->
        </div>
        <ol>
          <li [innerHTML]="'channel-connect_expedia_html_注意事项1' | translate">
            <!-- 1. Due to Booking.com's API restrictions,
        <span class="font-bold">reservations made before the connection cannot be synchronized to Hostex,</span> and
        the relevant automation rules cannot work. -->
          </li>
          <li [innerHTML]="'channel-connect_expedia_html_注意事项2' | translate">
            <!-- 2. <span class="font-bold">Remember to set the price</span> for your Booking.com listing in good time after
        you connect, as <span class="font-bold">Booking.com will erase any previous price settings.</span> -->
          </li>
        </ol>
      </div>

      <div [class]="footerClass">
        <button [class]="footerCancelBtnClass" nz-button nzSize="large" (click)="onCancel()">
          {{ "word.cancel" | translate }}
          <!-- Cancel -->
        </button>
        <button [class]="footerConfirmBtnClass" nz-button nzType="primary" nzSize="large" (click)="onNext()">
          {{ "channel-connect_booking_html_我明白了" | translate }}
          <!-- I understand and want to connect -->
        </button>
      </div>
    }

    @case (2) {
      <div class="v4-layout-form text-left">
        <div class="v4-layout-form-title !font-bold">
          {{ "channel-connect_expedia_html_booking登录" | translate }}
          <!-- Enter your Booking.com login -->
        </div>
        <div class="v4-layout-form-desc">
          {{ "channel-connect_expedia_html_booking输入邮箱" | translate }}
          <!-- Enter the email or username you use to log in to your Booking.com account. -->
        </div>
        <div class="v4-layout-field">
          <div class="v4-layout-field-control">
            <input
              type="text"
              nz-input
              nzSize="large"
              [placeholder]="'channel-connect_expedia_html_booking登录' | translate"
              [(ngModel)]="username" />
          </div>
        </div>

        <div [class]="footerClass">
          <button [class]="footerCancelBtnClass" nz-button nzSize="large" (click)="step = 1">
            {{ "word.return" | translate }}
            <!-- Back -->
          </button>
          <button
            [class]="footerConfirmBtnClass"
            nz-button
            nzSize="large"
            nzType="primary"
            [disabled]="!username"
            (click)="onNext()">
            {{ "word.next" | translate }}
            <!-- Next -->
          </button>
        </div>
      </div>
    }

    @case (3) {
      <div class="v4-layout-form">
        <div class="v4-layout-form-title !font-bold">
          {{ "channel-connect_booking_html_输入ids" | translate }}
          <!-- Input the hotel IDs you want to connect -->
        </div>
        <div class="v4-layout-form-desc">
          {{ "channel-connect_booking_html_复制ids" | translate }}
          <!-- Copy & paste all your hotel IDs you want to connect, one per line. Click on "Add" to add new lines. -->
        </div>
        @for (hotel of hotelIds; track i; let isFirst = $first, i = $index) {
          <div class="v4-layout-field">
            <div class="v4-layout-field-control">
              <div class="v4-layout-field-row relative">
                <input
                  type="text"
                  nz-input
                  nzSize="large"
                  [placeholder]="'channel-connect_with_booking_html_placeholder_id' | translate"
                  [(ngModel)]="hotel.value" />

                @if (!isFirst) {
                  <i
                    class="hidden md:block cursor-pointer absolute -right-5 top-1/2 -translate-y-1/2"
                    nz-icon
                    nzType="minus-circle"
                    nzTheme="fill"
                    (click)="onRemoveHotelId(i)"></i>

                  <Icon class="ml-2 md:hidden" [type]="'cross-circle-o'" (click)="onRemoveHotelId(i)"></Icon>
                }
              </div>
            </div>
          </div>
        }
        <div class="v4-layout-field">
          <div class="v4-layout-field-control">
            <button nz-button (click)="onAddHotelId()">
              {{ "channel-connect_booking_html_添加" | translate }}
              <!-- + Add -->
            </button>
          </div>
        </div>

        <div [class]="footerClass">
          <button [class]="footerCancelBtnClass" nz-button nzSize="large" (click)="step = 2">
            {{ "word.return" | translate }}
            <!-- Back -->
          </button>
          <button [class]="footerConfirmBtnClass" nz-button nzSize="large" nzType="primary" (click)="onNext()">
            {{ "word.next" | translate }}
            <!-- Next -->
          </button>
        </div>
      </div>
    }

    @case (4) {
      <div class="v4-layout-form">
        <div class="v4-layout-form-title !font-bold">
          {{ "channel-connect_booking_html_设置hostex" | translate }}
          <!-- Set Hostex as your connectivity provider -->
        </div>
        <div class="v4-layout-form-desc">
          <div class="text-m">
            1.
            <span class="hidden md:inline-block">
              <a
                class="font-bold"
                href="https://www.expediapartnercentral.com/Account/Logon?langId=1033&_ga=2.223085147.1961124670.1677775151-1707683221.1675724491"
                target="_blank">
                {{ "channel-connect_booking_html_点击登录" | translate }}
                <!-- Click to log in -->
              </a>
              {{ "channel-connect_expedia_html_跟随步骤" | translate }}
            </span>
            <span class="md:hidden">
              {{ "channel-connect_expedia_html_跟随步骤_mobile" | translate }}
              (<a
                class="font-bold"
                hostClipboard
                [clipboardData]="
                  'https://www.expediapartnercentral.com/Account/Logon?langId=1033&_ga=2.223085147.1961124670.1677775151-1707683221.1675724491'
                "
                href="javascript:void">
                {{ "channel-connect_booking_h5_html_复制链接" | translate }} </a
              >), {{ "channel-connect_expedia_html_跟随步骤1_mobile" | translate }}
            </span>
          </div>
          <div class="text-m">2. {{ "channel-connect_expedia_html_跟随步骤2" | translate }}</div>
          <div class="text-m">3. {{ "channel-connect_expedia_html_跟随步骤3" | translate }}</div>
        </div>
        <div class="text-m mt-[16px] mb-[16px]">
          {{ "channel-connect_expedia_html_跟随步骤4" | translate }}
        </div>
        <div class="v4-layout-field">
          <div class="v4-layout-field-control relative mb-[100px] md:mb-0" style="width: 100%">
            <img
              class="w-full hidden md:inline"
              src="https://oss.image.xiaogetech.com/CLJ1710927236619.png/large"
              alt="" />
            <img class="w-full md:hidden" src="https://oss.image.xiaogetech.com/WBE1712132359988.png/large" alt="" />
          </div>
        </div>
        <div [class]="footerClass">
          <button [class]="footerCancelBtnClass" nz-button nzSize="large" (click)="step = 3">
            {{ "word.return" | translate }}
            <!-- Back -->
          </button>
          <button
            [class]="footerConfirmBtnClass"
            nz-button
            nzSize="large"
            nzType="primary"
            (click)="onComplete()"
            [nzLoading]="loading">
            {{ "channel-connect_booking_html_完成" | translate }}
            <!-- I have finished -->
          </button>
        </div>
      </div>
    }

    <!-- @case (5) {
      <host-set-pricing-ratio (onBack)="step = 4" (onNext)="onFinish()"></host-set-pricing-ratio>
    } -->
  }
</div>
